import { Button, ButtonGroup, Content, Dialog, Divider, Heading } from '@adobe/react-spectrum';
import PropTypes from 'prop-types';
import React from 'react';

import { useStore } from '../../../store';

const appSubTypeMap = {
  ISV: 'an App Builder application',
  MSI: 'a server-to-server integration',
  ASC: 'an AEP Sources streaming connector',
};

const UnableToAcquirePluginDialog = (props) => {
  const { close } = props;
  const appSubType = useStore((state) => state.detailScreen?.appSubType);

  return (
    <Dialog>
      <Heading>Unable to acquire application</Heading>
      <Divider />
      <Content>
        <p>
          Only users belonging to an enterprise organization can acquire{' '}
          {appSubTypeMap[appSubType] || 'this application'}.
        </p>
        <p>
          If you belong to multiple organizations and one of them is an enterprise one, you can switch to it. To do so,
          please check your current organization in the top right corner of the page, where your profile details are
          shown. You can choose another organization from the same place. If your newly selected organization happens to
          be an enterprise one, you&apos;ll then be able to acquire this application
        </p>
      </Content>
      <ButtonGroup>
        <Button variant="secondary" onPress={close}>
          Close
        </Button>
      </ButtonGroup>
    </Dialog>
  );
};

export default UnableToAcquirePluginDialog;

UnableToAcquirePluginDialog.propTypes = {
  close: PropTypes.func,
};
